interface AvatarProps {
  initials: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Avatar({ initials, size = 'md', className = '' }: AvatarProps) {
  const sizeClasses = {
    sm: 'w-6 h-6 text-[10px]',
    md: 'w-7 h-7 text-[11px]',
    lg: 'w-8 h-8 text-[12px]'
  };

  return (
    <div className={`
      ${sizeClasses[size]}
      bg-canvas-2 text-ink-2 font-semibold rounded
      flex items-center justify-center
      ${className}
    `}>
      {initials}
    </div>
  );
}